export default __webpack_public_path__ + "static/media/millennium-falcon.99a74f81.png";